import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-screen-banner-a',
  templateUrl: './full-screen-banner-a.component.html',
  styleUrls: ['./full-screen-banner-a.component.css']
})
export class FullScreenBannerAComponent implements OnInit {

  // https://codepen.io/bradtraversy/pen/eYdMqvx
  
  constructor() { }

  ngOnInit(): void {
  }

}
